// --- Configuration ---
const MAX_FAILED_ATTEMPTS = 3;
let failedAttempts = 0;

// Placeholder AJAX URLs (replace with your actual server endpoints)
const AJAX_ACCESS_MANUAL_URL = 'https://kodiye.io/Order/getCodeKeysByEmail'; // Update if the endpoint is different
const AJAX_ACCESS_SECURE_URL = 'https://kodiye.io/Order/getCodeKeys';

// --- Utility Functions ---

/**
 * AJAX: Fetches codes using the secure URL ID.
 */
function fetchSecureAccess(secureId) {
    console.log(`AJAX: Attempting secure access with ID: ${secureId}`);

    return new Promise(resolve => {
        $.ajax({
            url: AJAX_ACCESS_SECURE_URL,
            method: 'POST',
            data: { o: secureId }, // Code Access uses 'o'
            dataType: 'json', // Expecting JSON response
            success: function (response) {
                resolve({ success: true, codes: response.keys });
            },
            error: function (xhr, status, error) {
                console.error("Secure Access API error:", xhr.responseJSON?.error?.message || error);
                resolve({ success: false, message: xhr.responseJSON?.error?.message || 'Access failed.' });
            }
        });
    });
}

/**
 * AJAX: Fetches codes using Order Number and Email.
 */
function fetchManualAccess(orderNum, email) {
    console.log(`AJAX: Attempting manual access for #${orderNum} / ${email}`);

    return new Promise(resolve => {
        $.ajax({
            url: AJAX_ACCESS_MANUAL_URL, 
            method: 'POST',
            data: { email: email, orderNumber: orderNum },
            dataType: 'json', // Expecting JSON response
            success: function (response) {
                console.log(response);
                resolve({ success: true, codes: response.keys });
            },
            error: function (xhr, status, error) {
                console.error("Manual Access API error:", xhr.responseJSON?.error?.message || error);
                resolve({ success: false, message: xhr.responseJSON?.error?.message || 'Access failed.' });
            }
        });
    });
}

/**
 * Function to create table html from response data
 */
function createTable(data) {
    if (!Array.isArray(data)) {
        console.error('Response data is not an array');
        return 'Invalid response format';
    }

    let tableHtml = '';

    data.forEach(item => {
        let keysList;
        if (item.codeType === 'LINK' || item.CodeType === 'LINK') {
            keysList = item.codeOrderKeys.map(key => `<li><a href="${key}" target="_blank" class="uk-code-link">${key}</a></li>`).join('');
        } else {
            keysList = item.codeOrderKeys.map(key => `<li>${key}</li>`).join('');
        }
        
        // Ensure defaults if properties are missing
        const platformName = item.platform || item.Platform || 'Activation Guide';
        const guideUrl = item.activationGuideUrl || item.ActivationGuideUrl || item.guideUrl || '#';
        const platformLogoUrl = item.PlatformLogoUrl || item.platformLogoUrl || '';
        
        let logoHtml = '';
        if (platformLogoUrl) {
            logoHtml = `<img src="${platformLogoUrl}" alt="${platformName}" style="width: 30px; height: 30px; object-fit: contain;">`;
        }
        
        let platformHtml = '';
        if (guideUrl !== '#') {
            platformHtml = `<a href="${guideUrl}" target="_blank" class="uk-guide-link" style="display: inline-flex; align-items: center; gap: 8px;">${logoHtml}<i class="fas fa-book-open"></i> <span>${platformName}</span></a>`;
        } else {
            platformHtml = `<span style="display: inline-flex; align-items: center; gap: 8px;">${logoHtml}<span>${platformName}</span></span>`;
        }

        let additionalInfoHtml = '';
        if (item.additionalKeyInfo && Array.isArray(item.additionalKeyInfo) && item.additionalKeyInfo.length > 0) {
            const additionalList = item.additionalKeyInfo.map(info => `<li style="margin-bottom: 4px;">${info}</li>`).join('');
            additionalInfoHtml = `<div class="additional-key-info" style="margin-top: 12px; font-size: 0.9rem; font-weight: normal; color: #555;"><ul style="list-style-type: disc; padding-left: 20px; margin: 0;">${additionalList}</ul></div>`;
        }

        tableHtml += `
        <tr>
            <td>${item.productName || 'N/A'}</td>
            <td>${platformHtml}</td>
            <td>
              <strong style="color: var(--color-secondary);"><ul class="keys-list" style="word-break: break-all;">${keysList}</ul></strong>
              ${additionalInfoHtml}
            </td>
        </tr>
        `;
    });

    return tableHtml;
}

/**
 * Hides the manual form and displays the contact message.
 */
function displayLockoutMessage() {
    $('#manual-inputs').slideUp();
    $('#unlock-button').prop('disabled', true);
    $('#unlock-button').slideUp();
    $('#error-message').slideUp();
    $('#form-description').slideUp();
    $('#failed-attempts-message').slideDown();
}

/**
 * Hides the manual form and displays the unlock redirection message.
 */
function displayUnlockRequiredMessage() {
    $('#manual-inputs').slideUp();
    $('#unlock-button').prop('disabled', true);
    $('#unlock-button').slideUp();
    $('#error-message').slideUp();
    $('#form-description').slideUp();

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('o') && !urlParams.has('id')) {
        urlParams.set('id', urlParams.get('o'));
    }
    const currentParams = urlParams.toString();
    const queryStr = currentParams ? '?' + currentParams : '';
    $('#unlock-redirect-button').attr('href', '/pages/unlock' + queryStr);

    $('#unlock-required-message').removeClass('d-none').slideDown();
}

/**
 * Renders the digital codes table on the screen.
 */
function renderCodesTable(codes) {
    // Create and display the table
    const tableHtml = createTable(codes);
    $('#codes-table tbody').html(tableHtml);

    // Hide everything else and show table
    $('#unlock-form-container').addClass('d-none').slideUp();
    $('#loader').hide();
    
    $('#codes-display-container').removeClass('d-none').show().addClass('anifadeIn');
    $("#headertext").css("margin-bottom", "35px");
}

// --- Main Logic ---

/**
 * Handles the visibility of form elements on page load based on URL ID.
 */
function initializePage() {
    const secureId = $('#url-secure-id').val();
    const $manualInputs = $('#manual-inputs');
    const $formDesc = $('#form-description');

    if (secureId) {
        // 1. Secure ID present: Hide manual inputs and change button text
        $manualInputs.addClass('d-none');
        $formDesc.html('<p class="subtext">Click **Access codes** to retrieve your digital content instantly.</p>');
        $('#unlock-button .button-text').text('Access My Codes');

        // Immediately trigger the secure access process
        handleAccessClick($('#unlock-button')[0]);

    } else {
        // 2. No Secure ID: Ensure form is visible (default state)
        $manualInputs.removeClass('d-none');
    }

    // Load failed attempts count from session storage if available
    const storedAttempts = sessionStorage.getItem('failedUnlockAttempts');
    if (storedAttempts && parseInt(storedAttempts) >= MAX_FAILED_ATTEMPTS) {
        displayLockoutMessage();
    }
}

/**
 * Main handler for the access button click.
 */
async function handleAccessClick(button) {
    const $button = $(button);
    const $error = $('#error-message');
    const secureId = $('#url-secure-id').val();

    $error.slideUp().text('');

    let accessResponse;

    try {
        // 1. Start Animation / Disable Button
        $button.prop('disabled', true).addClass('is-unlocking');
        $button.find('.unlock-spinner').show().removeClass('d-none');
        
        if (secureId) {
            // SCENARIO A: Secure Access via URL ID
            accessResponse = await fetchSecureAccess(secureId);
            if (!accessResponse.success) {
                const errorMsg = accessResponse.message || '';
                if (errorMsg.toLowerCase().includes('unlock')) {
                    displayUnlockRequiredMessage();
                    return;
                } else {
                    $error.text(errorMsg).slideDown();
                }
            }
        } else {
            // SCENARIO B: Manual Access via Form
            const orderNum = $('#order-number').val().trim();
            const email = $('#order-email').val().trim();

            // Check for lockout first
            const storedAttempts = parseInt(sessionStorage.getItem('failedUnlockAttempts') || '0');
            if (storedAttempts >= MAX_FAILED_ATTEMPTS) {
                displayLockoutMessage();
                return;
            }

            if (!orderNum || !email) {
                $error.text('Please fill in both the Order Number and Email.').slideDown();
                return;
            }

            // Perform the AJAX call for manual access
            accessResponse = await fetchManualAccess(orderNum, email);

            // 2. Handle Failure and Rate Limiting (SCENARIO B ONLY)
            if (!accessResponse.success) {
                const errorMsg = accessResponse.message || '';
                if (errorMsg.toLowerCase().includes('unlock')) {
                    displayUnlockRequiredMessage();
                    return;
                }

                failedAttempts = storedAttempts + 1;
                sessionStorage.setItem('failedUnlockAttempts', failedAttempts);

                let msg = errorMsg || 'The order details entered are incorrect.';
                $error.text(msg + (failedAttempts < MAX_FAILED_ATTEMPTS ? ` (${MAX_FAILED_ATTEMPTS - failedAttempts} attempts remaining)` : '')).slideDown();

                if (failedAttempts >= MAX_FAILED_ATTEMPTS) {
                    displayLockoutMessage();
                }
                else {
                    $error.text(errorMsg || 'Incorrect order details').slideDown();
                }
                return; // Exit here on failure, keeping button disabled until reset
            } else {
                // Clear attempts on success
                sessionStorage.removeItem('failedUnlockAttempts');
            }
        }

        // 3. Process Successful Access (SCENARIOS A and B)
        if (accessResponse.success && accessResponse.codes && accessResponse.codes.length > 0) {
            renderCodesTable(accessResponse.codes);
        } else if (accessResponse.success) {
            $error.text('Order validated, but no digital codes were found. Please contact support.').slideDown();
        }

    } catch (e) {
        console.error("Access failed:", e);
        $error.text('A server communication error occurred. Please try again later.').slideDown();
    } finally {
        // 4. Reset Button State (only if codes were NOT successfully displayed)
        if ($('#codes-display-container').css('display') === 'none' || $('#codes-display-container').hasClass('d-none')) {
            $button.prop('disabled', false).removeClass('is-unlocking');
            $button.find('.unlock-spinner').hide().addClass('d-none');
        }
    }
}

// Run initialization on document ready
$(document).ready(function () {
    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get('o');

    if (!orderId) {
        console.error('No order ID found in URL, waiting for manual entry.');
    } else {
        $('#url-secure-id').val(orderId);
    }

    initializePage();
    
    // Copy functionality for keys
    $(document).on('click', '.copy-icon', function () {
        const keys = $(this).data('keys');
        navigator.clipboard.writeText(keys).then(() => {
            $(this).addClass('copy-success');
            setTimeout(() => {
                $(this).removeClass('copy-success');
            }, 1500);
        });
    });
});